<template>
  <div>
    <anamnesis
      :dataCrud2.sync="localDataCrud"
      v-bind="{
        ...schema,
        handleEventsCrud,
        handleEvents,
        checkboxNone,
        handleEventsbox,
        save,
        clickRowInfo,
        remove,
        snackbar,
        overlay,
        overlayMessage,
        toggleOverlay,
        status,
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Anamnesis from '@/components/includes/Anamnesis';

export default {
  name: 'ANxAFxFamilyMembersPage',
  components: { Anamnesis },

  data: () => ({
    overlay: false,
    overlayMessage: '',
    backFamMemberId: null,
    valCheck: false,      
    localDataCrud: [],
  }),

  watch: {
    dataCrud: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.localDataCrud = JSON.parse(JSON.stringify(newValue));
        }
      }
    }
  },

  computed: {
    ...mapGetters('anamANxAFxFamilyMembers', [
      'schema',
      'catDiagnosticICD10',
      'catDiagnosticICD11',
      'catDiagnosticDSM5',
      'dataCrud',
      'checkboxNone',
      'isNewRecord',
      'status',
    ]),
    ...mapGetters('anamPermissions', ['hasPermission']),
    ...mapGetters('proProfileAPage', ['catDepartments']),
    ...mapGetters('proProfileAPage', ['catProvinces']),
    ...mapGetters('proProfileAPage', ['catDistricts']),
    ...mapGetters('notifications', ['snackbar']),
  },

  mounted() {
    this.loadData();
    this.loadCatDepartments();
    this.loadCatProvinces();
    this.loadCatDistricts();
  },

  methods: {
    ...mapActions('anamANxAFxFamilyMembers', [
      'fetchSchema',
      'fetchRecords',
      'createRecord',
      'updateRecord',
      'removeRecord',
    ]),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission']),
    ...mapActions('proProfileAPage', ['loadCatDepartments']),
    ...mapActions('proProfileAPage', ['loadCatProvinces']),
    ...mapActions('proProfileAPage', ['loadCatDistricts']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);
        
        if (this.hasPermission) {
          await this.fetchRecords();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    handleEventsbox(val) {
      this.valCheck = val;
    },

    handleEvents(val) {
      this.val = val;

      if (typeof val === 'object' && val !== null) {
        let nameProp = Object.hasOwn(val, 'ISO3366_1_comun_name');
        let nameProp1 = Object.hasOwn(val, 'departments');
        let nameProp2 = Object.hasOwn(val, 'provinces');
        let nameProp3 = Object.hasOwn(val, 'diagnostic_manual');

        if (nameProp || nameProp1 || nameProp2) {
          this.ubigeo();
        }

        if (nameProp3) {
          this.diagnosticManual();
        }
      }
    },

    clickRowInfo(clickItem) {
      this.backFamMemberId = clickItem?.back_fam_member_id ?? null;
      this.clickItemDiag = clickItem ?? null;

      if (typeof clickItem === 'object' && clickItem !== null) {
        let nameProp4 = Object.hasOwn(clickItem, 'back_fam_mental_diagnostic_manual');

        if (nameProp4) {
          this.initDiagManual();
        }
      }
    },

    ubigeo() {
      let obj = this.val;

      if (!obj) return;

      if (obj.departments !== undefined) {
        let val = obj.departments_id.toString();
        let element = this.catDepartments.find((el) => el.departments_id === val);
        let famMembDepartment = element.departments_id;
        let newCatProvinces = this.catProvinces.filter((item) =>
          item.departments_departments_id.includes(famMembDepartment)
        );
        this.schema.formCrud.back_fam_place_origin_province.items = newCatProvinces;
      } else if (obj.provinces !== undefined) {
        let val = obj.provinces_id;
        let element = this.catProvinces.find((el) => el.provinces_id === val);
        let famMembProvince = element.provinces_id;
        let newCatDistricts = this.catDistricts.filter((item) =>
          item.provinces_provinces_id.includes(famMembProvince)
        );
        this.schema.formCrud.back_fam_place_origin_district.items = newCatDistricts;
      }
    },

    initDiagManual() {
      let diseaseDiagManualId;
      !this.clickItemDiag.back_fam_disease_diagnostic_manual?.diagnostic_manual_id
        ? (diseaseDiagManualId = null)
        : (diseaseDiagManualId =
            this.clickItemDiag.back_fam_disease_diagnostic_manual?.diagnostic_manual_id);

      let mentalDiagManualId;
      !this.clickItemDiag.back_fam_mental_diagnostic_manual?.diagnostic_manual_id
        ? (mentalDiagManualId = null)
        : (mentalDiagManualId =
            this.clickItemDiag.back_fam_mental_diagnostic_manual?.diagnostic_manual_id);

      if (diseaseDiagManualId === 1) {
        this.schema.formCrud.back_fam_member_disease.items = this.catDiagnosticICD10;
      } else if (diseaseDiagManualId === 2) {
        this.schema.formCrud.back_fam_member_disease.items = this.catDiagnosticICD11;
      }

      if (mentalDiagManualId === 1) {
        let chapterVal = '05';
        const catDiagnosticICD10Mental = this.catDiagnosticICD10.filter((item) =>
          item.diagnostic_icd_10_chapter.includes(chapterVal)
        );
        this.schema.formCrud.back_fam_member_mental_problem.items = catDiagnosticICD10Mental;
      } else if (mentalDiagManualId === 2) {
        let chapterVal = '06';
        const catDiagnosticICD11Mental = this.catDiagnosticICD11.filter((item) =>
          item.diagnostic_icd_11_chapter.includes(chapterVal)
        );
        this.schema.formCrud.back_fam_member_mental_problem.items = catDiagnosticICD11Mental;
      } else if (mentalDiagManualId === 3) {
        this.schema.formCrud.back_fam_member_mental_problem.items = this.catDiagnosticDSM5;
      }
    },

    diagnosticManual() {
      let val = this.val;
      let manualId = val?.diagnostic_manual_id;
      let manualType = val?.type;

      if (manualType === 'disease') {
        if (manualId === 1) {
          this.schema.formCrud.back_fam_member_disease.items = this.catDiagnosticICD10;
        } else if (manualId === 2) {
          this.schema.formCrud.back_fam_member_disease.items = this.catDiagnosticICD11;
        }
      } else if (manualType === 'mental') {
        if (manualId === 1) {
          let chapterVal = '05';
          const catDiagnosticICD10Mental = this.catDiagnosticICD10.filter((item) =>
            item.diagnostic_icd_10_chapter.includes(chapterVal)
          );
          this.schema.formCrud.back_fam_member_mental_problem.items = catDiagnosticICD10Mental;
        } else if (manualId === 2) {
          let chapterVal = '06';
          const catDiagnosticICD11Mental = this.catDiagnosticICD11.filter((item) =>
            item.diagnostic_icd_11_chapter.includes(chapterVal)
          );
          this.schema.formCrud.back_fam_member_mental_problem.items = catDiagnosticICD11Mental;
        } else if (manualId === 3) {
          this.schema.formCrud.back_fam_member_mental_problem.items = this.catDiagnosticDSM5;
        }
      }
    },

    async save() {
      try {
        const model = { dataCrud: this.localDataCrud, checkboxNone: this.valCheck };
        const action = this.isNewRecord ? 'createRecord' : 'updateRecord';
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        this.fetchRecords();
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    async remove() {
      if (!this.backFamMemberId) {
        return this.showSnackbar('No hay un registro seleccionado.', 'warning');
      }

      try {
        await this.removeRecord({ id: this.backFamMemberId });
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackOkRemoved || 'Eliminado correctamente.'),
          'success'
        );      } catch (error) {
        console.error('Error al eliminar:', error);
        this.showSnackbar(this.sanitizeText(this.schema.snackError), 'error');
      }

      this.fetchRecords();
    },

    handleEventsCrud() {},

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>
